import { render, staticRenderFns } from "./HomeFitness.vue?vue&type=template&id=1746d060"
import script from "./HomeFitness.vue?vue&type=script&lang=js"
export * from "./HomeFitness.vue?vue&type=script&lang=js"
import style0 from "./HomeFitness.vue?vue&type=style&index=0&id=1746d060&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports